import React from 'react';
import _ from 'i18n';

const PageHeader = ({ header, subHeader, cssClass, icon, children, compon, periodFilter }) => {
  return (
    <div className={periodFilter ? 'page_header event-page-header' : 'page_header'}>
      <div className="page_header__icon">
        {icon && <img src={'/img/icons/' + icon + '.svg'} alt={''} />}
        {compon && <div className="flex">{compon}</div>}
      </div>
      <div className="page_header__info">
        <div>
          <h3>{_(header)}</h3>
          <p>{_(subHeader)}</p>
        </div>
      </div>
      <div className="page_header__children">{children}</div>
    </div>
  );
};

export default PageHeader;



// WEBPACK FOOTER //
// ./app/components/common/PageHeader/PageHeader.js